import { Link } from 'react-router';
import { Navigation } from './Navigation';
import { SurveyCtaBar } from './SurveyCtaBar';
import useHeaderHeight from './useHeaderHeight';

export function Header() {
  const { headerTranslateY, isRevealing, logoHeight } = useHeaderHeight();

  return (
    <div
      className="fixed top-0 left-0 right-0 z-20"
      style={{
        transform: `translateY(${headerTranslateY}px)`,
        transition: isRevealing ? 'transform 0.3s cubic-bezier(0.4,0,0.2,1)' : 'none',
      }}
    >
      <SurveyCtaBar />
      <header className="bg-white shadow">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src="/bidet-ny-logo-transparent.png"
                alt="Bidet New York Logo"
                style={{ height: logoHeight }}
                className="w-auto"
              />
            </Link>
          </div>
          <Navigation />
        </div>
      </header>
    </div>
  );
}
